import React, { useState, useEffect } from "react";
import Subscribe from "unstated-subscribe-hoc";

import HubStateContainer from "../../HubStateContainer";

import GardenForm from "./GardenForm";
import { fromRestFormat, toRestFormat, GardenType } from "./GardenType";
import Page from "../../ui/web/Page";

function GardenFormView({ context, ...props }) {
  const type = "gardens";
  const typeId = props.match.params.id || null;
  const typeData = context.state[type].selectedItem;
  const hasTypeId = !!typeId;

  const [dataLoaded, setDataLoaded] = useState(false);
  //const [dataUploading, setDataUploading] = useState(false);

  useEffect(() => {
    setDataLoaded(false);
    if (hasTypeId) {
      context.sync(type, typeId).then(() => {
        setDataLoaded(true);
      });
    }

    return () => {
      context.unsync(type);
    };
  }, [context, type, typeId, hasTypeId]);

  const uploadFile = (id, formFiles) => {
    if (formFiles.headerImage) {
      //setDataUploading(true);
      formFiles.headerImage.append("refId", id);
      formFiles.headerImage.append("ref", "garden");
      formFiles.headerImage.append("field", "headerImage");
      console.log("Uploading File...");
      context.upload(formFiles.headerImage);
    }
  };

  const handleFormSubmission = (formData, formFiles) => {
    if (typeId) {
      context.update(type, typeId, toRestFormat(formData)).then(updatedType => {
        uploadFile(updatedType.id, formFiles);
        props.history.goBack();
      });
    } else {
      context.add(type, toRestFormat(formData)).then(addedType => {
        uploadFile(addedType.id, formFiles);
        props.history.goBack();
      });
    }
  };

  const handleFormCancellation = () => {
    props.history.goBack();
  };

  return (
    <Page>
      {!typeId && (
        <GardenForm
          onSubmitted={handleFormSubmission}
          onCancelled={handleFormCancellation}
          typeData={GardenType}
        />
      )}
      {typeId && dataLoaded && (
        <GardenForm
          onSubmitted={handleFormSubmission}
          onCancelled={handleFormCancellation}
          typeData={fromRestFormat(typeData)}
        />
      )}
    </Page>
  );
}

export default Subscribe(GardenFormView, { context: HubStateContainer });
